import { render, staticRenderFns } from "./link-textarea.vue?vue&type=template&id=8df4d738&"
import script from "./link-textarea.vue?vue&type=script&lang=js&"
export * from "./link-textarea.vue?vue&type=script&lang=js&"
import style0 from "./link-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports